import gql from 'graphql-tag';

export const getEnabledModules = gql`
    query{
        behaviourComponents{
            key
            enabled
        }
    }
`;